import React, { useState, useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import "./Header.css";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import logo from "../../assets/images/logo1.png";
// import coin from '../../assets/images/coin.png';
import TemporaryDrawer from "./mobile_header";
// import { HttpService } from '../../service/HttpService';
import { Link, useHistory } from "react-router-dom";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const Header = (props) => {
  // useEffect(() => {
  //    getTotalPoints()
  // }, [])

  const [isOpen, setIsOpen] = useState(false);
  const [points, setPoints] = useState(0);

  const toggle = () => setIsOpen(!isOpen);
  // const httpService = new HttpService();
  const history = useHistory();

  // const getTotalPoints = () => {
  //   httpService.getApi('user/balance').then((response) => {
  //     if (response.data.balance != null){
  //       setPoints(response.data.balance)
  //     }

  //   }, (error) => {
  //     console.log(error);
  //   });
  // }

  // const redirect() {
  //   history.push({
  //     pathname: view,
  //   });
  // };

  // function redirect =(view)=>{
  //   history.push({
  //     pathname: view
  //   })
  // }

  function handleClick() {
    history.push("/home")
  }

  // const redirects =(view)=>{
  //   this.props.history.push({
  //     pathname: view
  //   })
  // }

  return (
    <>
      <Navbar className="main-header" light expand="md">
        {!props.isBackBtnShow &&
          <div className="back">
            <ArrowBackIosIcon
              onClick={handleClick} />
          </div>
        }
        <div className="logo">
          <span>
            <img src={logo} alt="logo" />
          </span>
        </div>

        {/* {props.loggedInUser == undefined && !props.loggedInUser && */}
        {/* <Collapse isOpen={isOpen} navbar> */}
        {/* <Nav className="mr-auto" navbar> */}
        {/* <div className="items"> */}
        {/* <NavItem>
                  <NavLink onClick={()=>redirect()} title="Account"><PermIdentityIcon className="user" /></NavLink>
                </NavItem>  */}
        {/* <NavItem>
                  <NavLink>
                    <span className="balance"><img src={coin} alt="coin-imgg" />{points}</span>
                  </NavLink>
                </NavItem>  */}
        {/* <NavItem>
                  <NavLink href="/ui/rvm" title="Log" onClick={() => localStorage.clear()}><ExitToAppIcon className="logout" /></NavLink>
                </NavItem> */}
        {/* </div>
            </Nav>
          </Collapse> */}
      </Navbar>
      <div className="mobile_menu">
        {/* {props.loggedInUser == undefined && !props.loggedInUser && 
          <TemporaryDrawer/>
        }  */}

        {!props.isBackBtnShow &&
          <div className="back">
            <ArrowBackIosIcon
              onClick={handleClick} />
          </div>
        }
        <div className="logo">
          <img className="img-fluid" src={logo} alt="logo-imgg" />
        </div>

        {/* {props.loggedInUser == undefined && !props.loggedInUser &&
          <span className="balance"><img src={coin} alt="coin-imgg" />{points}</span>
        }  */}
      </div>
    </>
  );
};
export default Header;
